import moment from 'moment';
import { cloneDeep } from 'lodash';
import gestionErreur from '@/services/general/gestionErreur';
import toastConfirmation from '@/services/general/toastConfirmation';
import customArraySort from '@/services/general/customArraySort';
import calculNbFacesReseauPersonnalise from '@/services/catalogue/calculNbFacesReseauPersonnalise';
import produitsCleaner from '@/services/panier/panierProduitsCleaner';
import preSauvegardeInitializer from '@/services/panier/preSauvegardeInitializer';
import preparationEnvoiBackOpp from '@/services/opportunite/preparationEnvoiBackOpp';
import {
  ZOOM_DEFAULT_LC,
  MARKER_POINT_DEFAUT,
  COULEUR_PUCE_DEFAULT,
  PANNEAUX_FROM_VENTES_LC,
  PANNEAUX_FROM_VENTES_NUMERIQUES,
  FACES_FROM_VENTES_RESEAUX,
} from '@/configuration/carteConf';
import fromTypeToMarkers from '@/services/catalogue/fromTypeToMarkers';
import * as panierConf from '@/components/creationOpportunite/configuration/panierConf';
import genererGuid from '@/services/general/genererGuid';
import getFacesReseauAsync from '@/services/reseauxTempo/getFaces';
import getAnneeSemaine, { getDateByJourAnneeSemaine } from '@/services/general/getAnneeSemaine';
import { OPTION } from '@/configuration/optionConf';
import { getDataDevisToOpp } from '@/services/panier/devis';
import preInitializerOpportunitePanier from '@/services/panier/preInitializerOpportunitePanier';
import {
  calculPrixTotalReseauTempo,
  calculPrixTotalVenteLc,
  calculPrixTotalVenteNumerique,
  calculPrixTotalReseauLc,
  calculPrixTotalReseauNumerique,
  calculPrixTotalReseauPersonnalise,
} from '@/services/panier/calculPrixTotal';
import arrondiResult from '@/services/general/arrondiCalcul';
import { APPLICATION_TVA_TYPE_NORMAL } from '@/configuration/applicationTvaConf';
import * as types from './panier-mutation-type';
import * as allTypes from '../mutation-type';
import { sendOpportunite, putOpportunite, browseDetailOpportunite, getPrevisualiserPdf } from '../../api/opportunite/index';

function initialState() {
  return {
    opportunitePanier: {
      panier: {
        produits: {
          panneauxLc: [],
          reseauxTempo: [],
          reseauxLc: [],
          reseauxPersonnalise: [],
          panneauxNumeriques: [],
          reseauxNumeriques: [],
        },
        client: {
          nomCommercial: null,
          latitude: null,
          longitude: null,
          applicationTva: APPLICATION_TVA_TYPE_NORMAL,
        },
        adressesProduits: [],
        contact: null,
        adresseClient: null,
        agenceId: null,
        version: 3,
      },
      themeCampagne: null,
      dateValidite: null,
      clientPanier: null,
    },
    adressesProduitsPanier: [],
    ouvrirEnvoiMail: false,
    opportunite: null,
    destinataires: [],
    adressePanier: null,
    activeTab: 0,
    markerFaceLC: [],
    markerPanneauNumerique: [],
    zoomCarto: ZOOM_DEFAULT_LC,
    markerFaceReseauxLc: [],
    markerFaceReseauxTempo: [],
    markerFaceReseauxNumerique: [],
    markerFaceReseauxPerso: [],
    isModif: false,
    idOppModif: '',
    isDuplicate: false,
    userIdentifiantOpp: '',
    prixGlobal: 0,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.ADD_PRODUIT_TYPE_PANNEAU](state, produit) {
    state.opportunitePanier.panier.produits.panneauxLc.push(produit);
  },
  [types.ADD_ADRESSES_PRODUITS](state, adresse) {
    if (state.adressesProduitsPanier[0] !== null && adresse) {
      const index = state.adressesProduitsPanier.findIndex(adr =>
        adr.lat === adresse.lat && adr.lng === adresse.lng);
      if (index === -1) state.adressesProduitsPanier.push(adresse);
    }
  },
  [types.REMOVE_ADRESSES_PRODUITS](state, adresse) {
    state.adressesProduitsPanier.splice(
      state.adressesProduitsPanier.indexOf(adresse), 1);
  },
  [types.REMOVE_PRODUIT_TYPE_PANNEAU](state, produit) {
    state.opportunitePanier.panier.produits
      .panneauxLc.splice(state.opportunitePanier.panier.produits.panneauxLc.indexOf(produit), 1);
  },
  [types.RESET_PANIER](state) {
    const s = initialState();
    state.opportunitePanier = s.opportunitePanier;
    state.markerFaceLC = s.markerFaceLC;
    state.markerPanneauNumerique = s.markerPanneauNumerique;
    state.markerFaceReseauxLc = s.markerFaceReseauxLc;
    state.markerFaceReseauxTempo = s.markerFaceReseauxTempo;
    state.markerFaceReseauxNumerique = s.markerFaceReseauxNumerique;
    state.isModif = s.isModif;
    state.isDuplicate = s.isDuplicate;
    state.idOppModif = s.idOppModif;
    state.adressesProduitsPanier = s.adressesProduitsPanier;
  },
  [types.TRIE_PRODUIT_TYPE_PANNEAU](state) {
    state.opportunitePanier.panier.produits.panneauxLc.sort(customArraySort(['ville', 'code']));
  },
  [types.ADD_PRODUIT_TYPE_RESEAU_TEMPO](state, produit) {
    state.opportunitePanier.panier.produits.reseauxTempo.push(produit);
  },
  [types.SET_PRODUIT_TYPE_RESEAU_TEMPO](state, data) {
    const index = state.opportunitePanier.panier.produits.reseauxTempo.findIndex((el) =>
      el.extensionOpportunite.semaine === data.semaine
      && el.extensionOpportunite.annee === data.annee
      && el.num === data.num);
    if (index !== -1) {
      state.opportunitePanier.panier.produits.reseauxTempo[index].listeFaces = data.faces;
    }
  },
  [types.REMOVE_PRODUIT_TYPE_RESEAU_TEMPO](state, produit) {
    state.opportunitePanier.panier.produits.reseauxTempo.splice(
      state.opportunitePanier.panier.produits.reseauxTempo.indexOf(produit), 1);
  },
  [types.TRIE_PRODUIT_TYPE_RESEAU_TEMPO](state) {
    state.opportunitePanier.panier.produits.reseauxTempo.sort((a, b) => {
      if (a.libelle < b.libelle) return -1;
      if (a.libelle === b.libelle) {
        if (a.extensionOpportunite.annee < b.extensionOpportunite.annee) return -1;
        if (a.extensionOpportunite.annee === b.extensionOpportunite.annee) {
          if (a.extensionOpportunite.semaine < b.extensionOpportunite.semaine) return -1;
          if (a.extensionOpportunite.semaine === b.extensionOpportunite.semaine) return 0;
        }
      }
      return 1;
    });
  },
  [types.ADD_PRODUIT_TYPE_RESEAU_LC](state, produit) {
    state.opportunitePanier.panier.produits.reseauxLc.push(produit);
  },
  [types.REMOVE_PRODUIT_TYPE_RESEAU_LC](state, produit) {
    state.opportunitePanier.panier.produits.reseauxLc.splice(
      state.opportunitePanier.panier.produits.reseauxLc.indexOf(produit), 1);
  },
  [types.ADD_PRODUIT_TYPE_PANNEAU_NUMERIQUE](state, produit) {
    state.opportunitePanier.panier.produits.panneauxNumeriques.push(produit);
  },
  [types.REMOVE_PRODUIT_TYPE_PANNEAU_NUMERIQUE](state, produit) {
    state.opportunitePanier.panier.produits.panneauxNumeriques.splice(
      state.opportunitePanier.panier.produits.panneauxNumeriques.indexOf(produit), 1);
  },
  [types.ADD_PRODUIT_TYPE_RESEAU_NUMERIQUE](state, produit) {
    state.opportunitePanier.panier.produits.reseauxNumeriques.push(produit);
  },
  [types.REMOVE_PRODUIT_TYPE_RESEAU_NUMERIQUE](state, produit) {
    state.opportunitePanier.panier.produits.reseauxNumeriques.splice(
      state.opportunitePanier.panier.produits.reseauxNumeriques.indexOf(produit), 1);
  },
  [types.SET_CLIENT_PANIER](state, client) {
    state.opportunitePanier.clientPanier = client;
  },
  [types.SET_CONTACT_PANIER](state, contact) {
    state.opportunitePanier.panier.contact = contact;
  },
  [types.SET_OUVRIR_ENVOI_MAIL](state, ouvrirEnvoiMail) {
    state.ouvrirEnvoiMail = ouvrirEnvoiMail;
  },
  [types.SET_OPPORTUNITE](state, opportunite) {
    state.opportunite = opportunite;
  },
  [types.SET_DESTINATAIRES](state, destinataires) {
    state.destinataires = destinataires;
  },
  [types.SET_THEME_CAMPAGNE](state, themeCampagne) {
    state.opportunitePanier.themeCampagne = themeCampagne;
  },
  [types.SET_DATE_VALIDITE](state, dateValidite) {
    state.opportunitePanier.dateValidite = dateValidite;
  },
  [types.SET_PANIER](state, panier) {
    state.opportunitePanier.panier = panier;
  },
  [types.REMOVE_PRODUIT_TYPE_RESEAU_PERSO](state, produit) {
    state.opportunitePanier.panier.produits.reseauxPersonnalise.splice(
      state.opportunitePanier.panier.produits.reseauxPersonnalise.indexOf(produit), 1);
  },
  [types.ADD_PRODUIT_TYPE_RESEAU_PERSONNALISE](state, reseau) {
    state.opportunitePanier.panier.produits.reseauxPersonnalise.push(reseau);
  },
  [types.SET_ADRESSE_PANIER](state, adressePanier) {
    state.adressePanier = adressePanier;
  },
  [types.SET_ACTIVE_TAB](state, activeTab) {
    state.activeTab = activeTab;
  },
  [types.SET_OPPORTUNITE_PANIER](state, opportunitePanier) {
    state.opportunitePanier = opportunitePanier;
  },
  [types.SET_MARKER_FACE_LC](state, markerFaceLC) {
    state.markerFaceLC = markerFaceLC;
  },
  [types.SET_MARKER_PANNEAU_NUMERIQUE](state, markerPanneauNumerique) {
    state.markerPanneauNumerique = markerPanneauNumerique;
  },
  [types.SET_ZOOM_CARTO](state, zoomCarto) {
    state.zoomCarto = zoomCarto;
  },
  [types.SET_MARKER_FACE_RESEAUX_LC](state, markerFaceReseauxLc) {
    state.markerFaceReseauxLc = markerFaceReseauxLc;
  },
  [types.SET_MARKER_FACE_RESEAUX_TEMPO](state, markerFaceReseauxTempo) {
    state.markerFaceReseauxTempo = markerFaceReseauxTempo;
  },
  [types.SET_MARKER_FACE_RESEAUX_NUMERIQUE](state, markerFaceReseauxNumerique) {
    state.markerFaceReseauxNumerique = markerFaceReseauxNumerique;
  },
  [types.SET_MARKER_FACE_RESEAUX_PERSO](state, markerFaceReseauxPerso) {
    state.markerFaceReseauxPerso = markerFaceReseauxPerso;
  },
  [types.SET_IS_MODIF](state, value) {
    state.isModif = value;
  },
  [types.SET_IS_DUPLICATE](state, value) {
    state.isDuplicate = value;
  },
  [types.SET_ID_OPP_MODIF](state, value) {
    state.idOppModif = value;
  },
  [types.SET_USER_IDENTIFIANT_OPP](state, value) {
    state.userIdentifiantOpp = value;
  },
  [types.SET_PRODUITS_PANIER](state, produits) {
    state.opportunitePanier.panier.produits = produits;
  },
  [types.UPDATE_PRIX_GLOBAL](state) {
    state.prixGlobal = arrondiResult(
      Object.values(state.opportunitePanier.panier.produits)
        .flat().map(el => el.prixTotal)
        .filter(el => el !== undefined)
        .reduce((el1, el2) => el1 + el2, 0),
    );
  },
};

const actions = {
  reseauTempoSelectionne: ({ getters }, resNum, annee, semaine) => {
    return getters.produits.reseauxTempo.find(produit =>
      (produit.num === resNum &&
        produit.extensionOpportunite.annee === annee &&
        produit.extensionOpportunite.semaine === semaine));
  },
  async genererOpportuniteData({ getters, rootGetters }) {
    // Pour éviter les décalages de date, on remplace l'objet Javascript
    // qui contient Date / Heure par juste la date en ISO8601
    const clonePanier = Object.assign({}, getters.panier);
    clonePanier.produits.panneauxLc.forEach((panneau) => {
      if (panneau.extensionOpportunite.date) {
        panneau.extensionOpportunite.dateDisponibilite =
          moment(panneau.extensionOpportunite.date).format('YYYY-MM-DD');
      }
      if (!panneau.extensionOpportunite.tarifAnnuel) {
        panneau.extensionOpportunite.tarifAnnuel = panneau.extensionOpportunite.tarifNet;
      }
    });
    clonePanier.produits.reseauxPersonnalise.forEach((reseau) => {
      if (reseau.dateDebut) {
        reseau.dateDebut = moment(reseau.dateDebut).format('YYYY-MM-DD');
      }
      if (reseau.dateFin) {
        reseau.dateFin = moment(reseau.dateFin).format('YYYY-MM-DD');
      }
    });
    await preSauvegardeInitializer(clonePanier.produits);
    clonePanier.client = {};

    clonePanier.produits.reseauxTempo.forEach((reseau) => {
      if (reseau.listeFaces.map(face => face.selected).includes(true)) {
        reseau.listeFaces = reseau.listeFaces
          .filter(face => face.selected);
      }
    });
    clonePanier.produits.reseauxLc.forEach((reseau) => {
      if (!reseau.extensionOpportunite.tarifBrut) {
        reseau.extensionOpportunite.tarifBrut = reseau.extensionOpportunite.tarifNet;
      }
    });
    clonePanier.produits.reseauxNumeriques.forEach((reseau) => {
      if (!reseau.tarifBrut) {
        reseau.tarifBrut = reseau.extensionOpportunite.tarifNet;
      }
    });
    if (getters.clientPanier) {
      clonePanier.client.nomCommercial = getters.clientPanier.nomCommercial;
      clonePanier.client.blocageLevel = getters.clientPanier.blocageLevel;
      clonePanier.client.applicationTva = getters.clientPanier.applicationTva;
      clonePanier.client.siren = getters.clientPanier.siren;
      if (getters.clientPanier.position !== undefined) {
        try {
          clonePanier.client.latitude = getters.clientPanier.position.lat();
          clonePanier.client.longitude = getters.clientPanier.position.lng();
        } catch (error) {
          clonePanier.client.latitude = getters.clientPanier.position.lat;
          clonePanier.client.longitude = getters.clientPanier.position.lng;
        }
      } else if (getters.clientPanier.adresse !== undefined) {
        clonePanier.client.latitude = getters.clientPanier.adresse.latitude;
        clonePanier.client.longitude = getters.clientPanier.adresse.longitude;
        clonePanier.adresseClient = getters.clientPanier.adresse;
      }
    }
    if (getters.adressesProduitsPanier.length) {
      clonePanier.adressesProduits = [];
      let adresses = getters.adressesProduitsPanier.filter(adr => adr.nom === 'adresseFaceLc');
      if (adresses.length === 1) clonePanier.adressesProduits.push(adresses[0]);
      adresses = getters.adressesProduitsPanier.filter(adr => adr.nom === 'adresseReseauxTempo');
      if (adresses.length === 1) clonePanier.adressesProduits.push(adresses[0]);
      adresses = getters.adressesProduitsPanier.filter(adr => adr.nom === 'adresseReseauxLc');
      if (adresses.length === 1) clonePanier.adressesProduits.push(adresses[0]);
      adresses = getters.adressesProduitsPanier.filter(adr => adr.nom === 'adresseReseauxNumeriques');
      if (adresses.length === 1) clonePanier.adressesProduits.push(adresses[0]);
      adresses = getters.adressesProduitsPanier.filter(adr => adr.nom === 'adresseVenteNumerique');
      if (adresses.length === 1) clonePanier.adressesProduits.push(adresses[0]);
    }

    let cliNum = null;
    if (getters.clientPanier) {
      cliNum = getters.clientPanier.num;
    }
    let estGuid = false;
    if (cliNum != null && cliNum.includes('-')) {
      estGuid = true;
    }

    let themeCampagne = getters.themeCampagne || '';
    if (themeCampagne.includes('\t')) themeCampagne = themeCampagne.replace('\t', '');

    clonePanier.agenceId = rootGetters['user/agenceId'];
    produitsCleaner(clonePanier.produits);
    const opportunite = {
      userId: getters.userIdentifiantOpp,
      annonceurId: estGuid ? null : cliNum,
      annonceurGuid: estGuid ? cliNum : '',
      data: clonePanier,
      themeCampagne: themeCampagne.trim(),
      dateValidite: getters.dateValidite ? moment(getters.dateValidite).format('YYYYMMDD') : '',
    };
    return preparationEnvoiBackOpp(opportunite);
  },
  async envoyerOpportunite({ getters, commit, dispatch }, payload) {
    try {
      let opp = {};
      if (payload.opp) opp = payload.opp;
      else opp = await dispatch('genererOpportuniteData');

      let response = {};
      if (getters.isModif) {
        opp.userId = getters.userIdentifiantOpp;
        await putOpportunite(getters.idOppModif, opp);
        toastConfirmation('Modifications sauvegardées');
        response = await browseDetailOpportunite(getters.idOppModif);
      } else {
        response = await sendOpportunite(opp);
      }
      commit(types.RESET_PANIER);
      response.data.url = 'opportunites/' + response.data.id + '/action/pdf';
      response.data.urlRecap = 'opportunites/' + response.data.id + '/action/recap';
      response.data.afficherRecap = false;
      if (response.data.data.produits.reseauxTempo.length > 0
          || response.data.data.produits.reseauxPersonnalise.length > 0) {
        response.data.afficherRecap = true;
      }
      // response.data.data.produits = {};
      commit(types.SET_OPPORTUNITE, response.data);
      toastConfirmation('Opportunité enregistrée avec succès');
      return {
        opp: response.data,
      };
    } catch (e) {
      gestionErreur('Erreur de l\'enregistrement de l\'opportunité', e);
      throw e;
    }
  },
  async previsualiserOpportunite({ dispatch }) {
    try {
      const opportunite = await dispatch('genererOpportuniteData');
      const response = await getPrevisualiserPdf(opportunite);
      return response;
    } catch (e) {
      gestionErreur('Erreur lors de la réception du pdf de l\'opportunité', e);
      throw e;
    }
  },
  async getFacesDeReseau({ commit }, payload) {
    try {
      const query = {
        params: {
          dateVisualisation: payload.dateDebut,
          anneeSemaine: getAnneeSemaine(
            payload.reseau.extensionOpportunite.annee,
            payload.reseau.extensionOpportunite.semaine,
          ),
          jourDepart: payload.reseau.jourDepart,
          societeId: payload.reseau.socCode,
          selectionFaceForOption: payload.reseau.extensionOpportunite.demande === OPTION,
          ForPartialSelection: true,
          referenceVentePartielle: payload.reseau.extensionOpportunite.referenceVentePartielle,
          ligneCommandeId: payload.reseau.extensionOpportunite.idLigneDeCommande,
        },
      };
      const faces = await getFacesReseauAsync(
        payload.reseau.num,
        query,
        payload.reseau.listeFaces,
      );
      commit(types.SET_PRODUIT_TYPE_RESEAU_TEMPO, {
        semaine: payload.reseau.extensionOpportunite.semaine,
        annee: payload.reseau.extensionOpportunite.annee,
        num: payload.reseau.num,
        faces,
      });
    } catch (err) {
      throw err;
    }
  },
  async miseAJourListeFacesReseau({ getters, dispatch }) {
    try {
      const promesses = [];
      getters.reseauxTempoPanier.forEach((reseau) => {
        const dateDebut = getDateByJourAnneeSemaine(
          reseau.jourDepart,
          reseau.extensionOpportunite.annee,
          reseau.extensionOpportunite.semaine).format('YYYYMMDD');
        promesses.push(dispatch('getFacesDeReseau', { reseau: reseau, dateDebut: dateDebut }));
      });

      await Promise.all(promesses);
    } catch (err) {
      throw err;
    }
  },
  removeReseauPersonnalise({ getters, commit }, payload) {
    const reseauPerso = getters.panier.produits.reseauxPersonnalise.find((el) => {
      return el.reseauPersoGuid === payload.response.extensionOpportunite.guid;
    });
    if (reseauPerso) {
      reseauPerso.produits.forEach((el) => {
        if (el.type === panierConf.TYPE_RESEAU_PERSONNALISE_FACE &&
          el.num === payload.response.extensionOpportunite.faceSelectionne.facNum) {
          reseauPerso.produits.splice(reseauPerso.produits.indexOf(el), 1);
        }
        if (el.type === panierConf.TYPE_RESEAU_PERSONNALISE_RESEAU_TEMPORAIRE &&
          el.num === payload.response.num &&
          el.annee === payload.response.extensionOpportunite.annee &&
          el.semaine === payload.response.extensionOpportunite.semaine) {
          reseauPerso.produits.splice(reseauPerso.produits.indexOf(el), 1);
        }
        if (el.type === panierConf.TYPE_RESEAU_PERSONNALISE_RESEAU_LC &&
          el.num === payload.response.num) {
          reseauPerso.produits.splice(reseauPerso.produits.indexOf(el), 1);
        }
      });
      reseauPerso.nbFaces = calculNbFacesReseauPersonnalise(reseauPerso.produits);
      reseauPerso.nbProduits = reseauPerso.produits.length;
      if (reseauPerso.nbProduits === 0) {
        commit(types.REMOVE_PRODUIT_TYPE_RESEAU_PERSO, reseauPerso);
      }
    }
  },
  creerReseauPersonnalise({ getters, commit, dispatch }) {
    const guid = genererGuid();
    const produits = [];
    const produitsWithAllData = [];
    let urlPhoto = null;
    const panier = getters.panier;
    let dateDepart = null;
    let dateFin = null;
    panier.produits.panneauxLc.forEach((el) => {
      if (el.selected) {
        el.selected = false;
        el.extensionOpportunite.reseauPersoGuid = guid;
        produits.push({
          num: el.extensionOpportunite.faceSelectionne.facNum,
          type: panierConf.TYPE_RESEAU_PERSONNALISE_FACE,
          nom: el.extensionOpportunite.faceSelectionne.facCode,
          ville: el.ville,
          nbFaces: 1,
          tarifHT: el.extensionOpportunite.tarifAnnuel ? el.extensionOpportunite.tarifAnnuel : 0,
          tarifNet: el.extensionOpportunite.tarifNet ? el.extensionOpportunite.tarifNet : 0,
          taxeMunicipale: el.extensionOpportunite.taxeMunicipale ?
            el.extensionOpportunite.taxeMunicipale : 0,
          tarifDePose: el.extensionOpportunite.tarifDePose ?
            el.extensionOpportunite.tarifDePose : 0,
        });
        produitsWithAllData.push({
          dataProduit: el,
          typeProduit: PANNEAUX_FROM_VENTES_LC,
        });
        if (!urlPhoto && el.extensionOpportunite.faceSelectionne.urlPhoto) {
          urlPhoto = el.extensionOpportunite.faceSelectionne.urlPhoto;
        }
        if (el.extensionOpportunite.date) {
          if (el.extensionOpportunite.date < dateDepart || !dateDepart) {
            dateDepart = el.extensionOpportunite.date;
          }
        }
      }
    });
    panier.produits.reseauxTempo.forEach((el) => {
      if (!el.selected) {
        return;
      }
      el.selected = false;
      el.extensionOpportunite.reseauPersoGuid = guid;
      produits.push({
        num: el.num,
        type: panierConf.TYPE_RESEAU_PERSONNALISE_RESEAU_TEMPORAIRE,
        nom: el.libelle,
        semaine: el.extensionOpportunite.semaine,
        annee: el.extensionOpportunite.annee,
        ville: el.ville,
        nbFaces: parseInt(el.extensionOpportunite.facesSouhaitees, 10),
        tarifHT: el.extensionOpportunite.tarifHT ? el.extensionOpportunite.tarifHT : 0,
        tarifNet: el.extensionOpportunite.tarifNet ? el.extensionOpportunite.tarifNet : 0,
        taxeMunicipale: el.extensionOpportunite.taxeMunicipale ?
          el.extensionOpportunite.taxeMunicipale : 0,
        tarifDePose: el.extensionOpportunite.tarifDePose ?
          el.extensionOpportunite.tarifDePose : 0,
        tarifImpression: el.extensionOpportunite.tarifImpression ?
          el.extensionOpportunite.tarifImpression : 0,
      });
      const faces = el.listeFaces;
      faces.forEach((face) => {
        if (face.latitude !== 0 && face.longitude !== 0 &&
          Math.trunc(face.latitude) > 0 &&
          Math.trunc(face.longitude) > 0) {
          if (el.couleur) {
            face.color = el.couleur;
          }
          face.libelleReseau = el.libelle;
          produitsWithAllData.push({
            dataProduit: face,
            typeProduit: FACES_FROM_VENTES_RESEAUX,
          });
        }
      });
      if (!urlPhoto && el.urlPhoto) {
        urlPhoto = el.urlPhoto;
      }
      const dateDepartReseau = getDateByJourAnneeSemaine(
        el.jourDepart,
        el.extensionOpportunite.annee,
        el.extensionOpportunite.semaine);
      const dateFinReseau = moment(dateDepartReseau).add(6, 'days');
      if (dateDepartReseau < dateDepart || !dateDepart) {
        dateDepart = dateDepartReseau;
      }
      if (dateFinReseau > dateFin || !dateFin) {
        dateFin = dateFinReseau;
      }
    });
    panier.produits.reseauxLc.forEach((el) => {
      if (el.selected) {
        el.selected = false;
        el.extensionOpportunite.reseauPersoGuid = guid;
        produits.push({
          num: el.num,
          type: panierConf.TYPE_RESEAU_PERSONNALISE_RESEAU_LC,
          nom: el.libelle,
          ville: el.ville,
          nbFaces: el.nbFaces,
          tarifHT: el.tarifBut ? el.tarifBut : 0,
          tarifNet: el.extensionOpportunite.tarifNet ? el.extensionOpportunite.tarifNet : 0,
          taxeMunicipale: el.extensionOpportunite.taxeMunicipale ?
            el.extensionOpportunite.taxeMunicipale : 0,
          tarifDePose: el.extensionOpportunite.tarifDePose ?
            el.extensionOpportunite.tarifDePose : 0,
        });
        const faces = el.listeFaces;
        faces.forEach((face) => {
          if (face.latitude !== 0 && face.longitude !== 0 &&
            Math.trunc(face.latitude) > 0 &&
            Math.trunc(face.longitude) > 0) {
            face.selected = el.selected;
            if (el.couleur) {
              face.color = el.couleur;
            }
            face.libelleReseau = el.libelle;
            produitsWithAllData.push({
              dataProduit: face,
              typeProduit: FACES_FROM_VENTES_RESEAUX,
            });
          }
        });
        if (!urlPhoto && el.urlPhoto) {
          urlPhoto = el.urlPhoto;
        }
        if (el.extensionOpportunite.date) {
          if (el.extensionOpportunite.date < dateDepart || !dateDepart) {
            dateDepart = el.extensionOpportunite.date;
          }
        }
      }
    });
    panier.produits.panneauxNumeriques.forEach((el) => {
      if (el.selected) {
        el.selected = false;
        el.extensionOpportunite.reseauPersoGuid = guid;
        produits.push({
          num: el.num,
          type: panierConf.TYPE_RESEAU_PERSONNALISE_PANNEAU_NUMERIQUE,
          nom: el.code,
          ville: el.ville,
          nbFaces: 1,
          tarifHT: el.extensionOpportunite.tarifHt ? el.extensionOpportunite.tarifHt : 0,
          taxeMunicipale: el.extensionOpportunite.taxeMunicipale ?
            el.extensionOpportunite.taxeMunicipale : 0,
        });
        produitsWithAllData.push({
          dataProduit: el,
          typeProduit: PANNEAUX_FROM_VENTES_NUMERIQUES,
        });
        if (!urlPhoto && el.urlPhoto) {
          urlPhoto = el.urlPhoto;
        }
      }
    });
    panier.produits.reseauxNumeriques.forEach((el) => {
      if (el.selected) {
        el.selected = false;
        el.extensionOpportunite.reseauPersoGuid = guid;
        produits.push({
          num: el.num,
          type: panierConf.TYPE_RESEAU_PERSONNALISE_RESEAU_NUMERIQUE,
          nom: el.code,
          ville: el.ville,
          nbFaces: el.nbFaces,
          tarifHT: el.tarifBrut ? el.tarifBrut : 0,
          tarifNet: el.extensionOpportunite.tarifNet ? el.extensionOpportunite.tarifNet : 0,
          taxeMunicipale: el.extensionOpportunite.taxeMunicipale ?
            el.extensionOpportunite.taxeMunicipale : 0,
        });
        const faces = el.listeFaces;
        faces.forEach((face) => {
          if (face.latitude !== 0 && face.longitude !== 0 &&
            Math.trunc(face.latitude) > 0 &&
            Math.trunc(face.longitude) > 0) {
            face.selected = el.selected;
            if (el.couleur) {
              face.color = el.couleur;
            }
            face.libelleReseau = el.libelle;
            produitsWithAllData.push({
              dataProduit: face,
              typeProduit: FACES_FROM_VENTES_RESEAUX,
            });
          }
        });
        if (!urlPhoto && el.urlPhoto) {
          urlPhoto = el.urlPhoto;
        }
      }
    });
    commit(types.SET_PANIER, panier);
    if (!dateDepart) {
      dateDepart = moment();
    }
    if (!dateFin) dateFin = moment().add(6, 'days');
    if (dateFin < dateDepart) dateFin = moment(dateDepart).add(6, 'days');
    let tarifHT = 0;
    let tarifNet = 0;
    let taxeMunicipale = 0;
    let tarifImpression = 0;
    let tarifDePose = 0;
    produits.forEach((el) => {
      if (el.tarifHT) tarifHT += el.tarifHT;
      if (el.tarifNet) tarifNet += el.tarifNet;
      if (el.taxeMunicipale) taxeMunicipale += el.taxeMunicipale;
      if (el.tarifImpression) tarifImpression += el.tarifImpression;
      if (el.tarifDePose) tarifDePose += el.tarifDePose;
    });
    const nouveauReseauPersonnalise = {
      guid: guid,
      libelle: '',
      nbProduits: produits.length,
      nbFaces: calculNbFacesReseauPersonnalise(produits),
      dateDebut: new Date(dateDepart),
      dateFin: new Date(dateFin),
      taxeMunicipale,
      tarifHT,
      tarifNet,
      tarifDePose,
      tarifImpression: tarifImpression,
      icon: MARKER_POINT_DEFAUT,
      commentaire: '',
      produits: produits,
      urlPhoto: urlPhoto,
      couleur: COULEUR_PUCE_DEFAULT,
      masquerFaceEdition: null,
      produitsWithAllData: produitsWithAllData,
    };
    commit(types.ADD_PRODUIT_TYPE_RESEAU_PERSONNALISE, nouveauReseauPersonnalise);
    dispatch('genererMarkerFaceReseauxPerso');
  },
  async rechargerOpportunite({ rootGetters, commit, dispatch, getters }, payload) {
    commit(types.SET_ID_OPP_MODIF, payload);
    let opportunite = rootGetters['opportunites/mesOpportunites'].find((el) => { return el.id === payload; });
    if (!opportunite) opportunite = (await browseDetailOpportunite(payload)).data;
    preInitializerOpportunitePanier(opportunite);
    await getDataDevisToOpp(opportunite);
    let clientComplet = null;
    const cliNum = opportunite.annonceurGuid ? opportunite.annonceurGuid : opportunite.annonceurId;
    if (cliNum) {
      try {
        await dispatch('client/rechercheDetailClient', { cliNum }, { root: true });
        clientComplet = rootGetters['client/client'];
      } catch (error) {
        clientComplet = null;
      }
    } else if (opportunite.data.client && opportunite.data.client.nomCommercial) {
      clientComplet = {
        nomCommercial: opportunite.data.client.nomCommercial,
        latitude: opportunite.data.client.latitude,
        longitude: opportunite.data.client.longitude,
        adrVille: '',
        applicationTva: opportunite.data.client.applicationTva || APPLICATION_TVA_TYPE_NORMAL,
        siren: opportunite.data.client.siren,
      };
    }
    if (!getters.isModif) delete opportunite.data.devisObject;
    if (getters.isDuplicate) {
      if (opportunite.data.valider) opportunite.data.valider = false;
      if (opportunite.data.produits.reseauxTempo.length > 0) {
        opportunite.data.produits.reseauxTempo.forEach(res => {
          if (res.extensionOpportunite.demande) {
            res.extensionOpportunite.demande = '';
            res.extensionOpportunite.etatObtenu = '';
            res.extensionOpportunite.referenceVentePartielle = '';
            res.extensionOpportunite.dateEtatObtenu = null;
            res.extensionOpportunite.dateEtatSouhaite = null;
            res.extensionOpportunite.idLigneDeCommande = null;
          }
        });
      }
    }
    commit(types.SET_USER_IDENTIFIANT_OPP, opportunite.userId);
    const opportunitePanier = {
      panier: opportunite.data,
      themeCampagne: opportunite.themeCampagne,
      dateValidite: opportunite.dateValidite,
      clientPanier: clientComplet,
    };
    commit(types.SET_OPPORTUNITE_PANIER, opportunitePanier);
    dispatch('genererMarkerPanneauxLc');
    dispatch('genererMarkerPanneauxNumerique');
    dispatch('genererMarkerFaceReseauxLc');
    dispatch('genererMarkerFaceReseauxTempo');
    dispatch('genererMarkerFaceReseauxNumerique');
    dispatch('genererMarkerFaceReseauxPerso');
  },
  genererMarkerPanneauxLc({ getters, commit, rootGetters }) {
    const azimut = rootGetters['user/afficherAzimut'];
    const markers = fromTypeToMarkers(PANNEAUX_FROM_VENTES_LC, getters.panneauxLcPanier, azimut);
    commit(types.SET_MARKER_FACE_LC, markers);
  },
  genererMarkerPanneauxNumerique({ getters, commit, rootGetters }) {
    const azimut = rootGetters['user/afficherAzimut'];
    const markers = fromTypeToMarkers(PANNEAUX_FROM_VENTES_NUMERIQUES,
      getters.panneauxNumeriquesPanier, azimut);
    commit(types.SET_MARKER_PANNEAU_NUMERIQUE, markers);
  },
  genererMarkerFaceReseauxLc({ getters, commit, rootGetters }) {
    const allFaces = [];
    const azimut = rootGetters['user/afficherAzimut'];
    getters.reseauxLcPanier.forEach((reseau) => {
      const faces = reseau.listeFaces;
      faces.forEach((face) => {
        if (face.latitude !== 0 && face.longitude !== 0
          && Math.trunc(face.latitude) > 0
          && Math.trunc(face.longitude) > 0) {
          face.selected = reseau.selected;
          if (reseau.couleur) {
            face.color = reseau.couleur;
          }
          face.libelleReseau = reseau.libelle;
          allFaces.push(face);
        }
      });
    });
    commit(types.SET_MARKER_FACE_RESEAUX_LC, fromTypeToMarkers(FACES_FROM_VENTES_RESEAUX,
      allFaces, azimut));
  },
  genererMarkerFaceReseauxTempo({ getters, commit, rootGetters }) {
    const allFaces = [];
    const azimut = rootGetters['user/afficherAzimut'];
    getters.reseauxTempoPanier.forEach((reseau) => {
      const faces = reseau.listeFaces;
      faces.forEach((face) => {
        if (face.latitude !== null && face.longitude !== null
          && face.latitude !== 0 && face.longitude !== 0) {
          if (reseau.couleur) {
            face.color = reseau.couleur;
          }
          face.libelleReseau = reseau.libelle;
          allFaces.push(face);
        }
      });
    });
    commit(types.SET_MARKER_FACE_RESEAUX_TEMPO, fromTypeToMarkers(FACES_FROM_VENTES_RESEAUX,
      allFaces, azimut));
  },
  genererMarkerFaceReseauxNumerique({ getters, commit, rootGetters }) {
    const allFaces = [];
    const azimut = rootGetters['user/afficherAzimut'];
    getters.reseauxNumeriquesPanier.forEach((reseau) => {
      const faces = reseau.listeFaces;
      faces.forEach((face) => {
        if (face.latitude !== 0 && face.longitude !== 0
            && Math.trunc(face.latitude) > 0
            && Math.trunc(face.longitude) > 0) {
          face.selected = reseau.selected;
          if (reseau.couleur) {
            face.color = reseau.couleur;
          }
          face.libelleReseau = reseau.libelle;
          allFaces.push(face);
        }
      });
    });
    commit(types.SET_MARKER_FACE_RESEAUX_NUMERIQUE, fromTypeToMarkers(FACES_FROM_VENTES_RESEAUX,
      allFaces, azimut));
  },
  genererMarkerFaceReseauxPerso({ getters, commit, rootGetters }) {
    const azimut = rootGetters['user/afficherAzimut'];
    const markers = [];
    getters.panier.produits.reseauxPersonnalise.forEach(reseau => {
      const facesLc = reseau.produitsWithAllData
        .filter(face => face.typeProduit === PANNEAUX_FROM_VENTES_LC)
        .map(el => el.dataProduit);
      const markerFaceLc = fromTypeToMarkers(PANNEAUX_FROM_VENTES_LC, facesLc, azimut);
      const facesNum = reseau.produitsWithAllData
        .filter(face => face.typeProduit === PANNEAUX_FROM_VENTES_NUMERIQUES)
        .map(el => el.dataProduit);
      const markerFaceNum = fromTypeToMarkers(PANNEAUX_FROM_VENTES_NUMERIQUES, facesNum, azimut);
      const facesReseaux = reseau.produitsWithAllData
        .filter(face => face.typeProduit === FACES_FROM_VENTES_RESEAUX)
        .map(el => el.dataProduit);
      const markerFaceReseau = fromTypeToMarkers(FACES_FROM_VENTES_RESEAUX, facesReseaux, azimut);
      const tempTab = markerFaceLc.concat(markerFaceNum);
      markers.push(...tempTab.concat(markerFaceReseau));
    });
    commit(types.SET_MARKER_FACE_RESEAUX_PERSO, markers);
  },
  parametreEdition({ getters, commit }, payload) {
    const produits = cloneDeep(getters.produits);
    produits.panneauxLc.forEach((panneau) => {
      panneau.extensionOpportunite.infoTarifLc = payload.infoTarifLc;
      panneau.extensionOpportunite.dateLc = payload.dateLc;
    });
    produits.reseauxTempo.forEach((reseau) => {
      reseau.extensionOpportunite.infoTarifReseau = payload.infoTarifReseau;
      reseau.extensionOpportunite.dateReseau = payload.dateReseau;
      reseau.extensionOpportunite.masquerFaceEdition = payload.listesFaesReseau;
      reseau.extensionOpportunite.visualiserCarteEdition = payload.cartoReseau;
    });
    produits.reseauxLc.forEach((reseau) => {
      reseau.extensionOpportunite.infoTarifReseau = payload.infoTarifReseau;
      reseau.extensionOpportunite.dateReseau = payload.dateReseau;
      reseau.extensionOpportunite.masquerFaceEdition = payload.listesFaesReseau;
      reseau.extensionOpportunite.visualiserCarteEdition = payload.cartoReseau;
    });
    commit(types.SET_PRODUITS_PANIER, produits);
  },
};

const getters = {
  panier(state) {
    const panier = state.opportunitePanier.panier;
    panier.produits.reseauxLc.forEach(reseau => {
      reseau.prixTotal = calculPrixTotalReseauLc(reseau);
      reseau.extensionOpportunite.date = new Date(reseau.extensionOpportunite.date);
      reseau.extensionOpportunite.tarifInformation = reseau.extensionOpportunite.tarifInformation ? reseau.extensionOpportunite.tarifInformation : '';
      if (reseau.extensionOpportunite.masquerRemiseEdition === undefined) {
        reseau.extensionOpportunite.masquerRemiseEdition = false;
      }
      if (reseau.urlPhoto != null) reseau.urlPhoto = reseau.urlPhoto.replace('http://client.affixe-logiciel.fr', 'https://secure.affixe-logiciel.fr');
    });
    panier.produits.reseauxTempo.forEach(reseau => {
      reseau.prixTotal = calculPrixTotalReseauTempo(reseau);
      if (reseau.extensionOpportunite.masquerRemiseEdition === undefined) {
        reseau.extensionOpportunite.masquerRemiseEdition = false;
      }
      if (reseau.urlPhoto != null) reseau.urlPhoto = reseau.urlPhoto.replace('http://client.affixe-logiciel.fr', 'https://secure.affixe-logiciel.fr');
    });
    panier.produits.reseauxNumeriques.forEach(reseau => {
      reseau.prixTotal = calculPrixTotalReseauNumerique(reseau);
      reseau.extensionOpportunite.tarifInformation = reseau.extensionOpportunite.tarifInformation ? reseau.extensionOpportunite.tarifInformation : '';
      if (reseau.extensionOpportunite.masquerFaceEdition === undefined) {
        reseau.extensionOpportunite.masquerFaceEdition = true;
      }
      if (reseau.urlPhoto != null) reseau.urlPhoto = reseau.urlPhoto.replace('http://client.affixe-logiciel.fr', 'https://secure.affixe-logiciel.fr');
    });
    panier.produits.reseauxPersonnalise.forEach(reseau => {
      reseau.prixTotal = calculPrixTotalReseauPersonnalise(reseau);
      reseau.tarifInformation = '/ an';
      reseau.dateDebut = new Date(reseau.dateDebut);
      reseau.dateFin = new Date(reseau.dateFin);
      if (reseau.urlPhoto != null) reseau.urlPhoto = reseau.urlPhoto.replace('http://client.affixe-logiciel.fr', 'https://secure.affixe-logiciel.fr');
    });
    panier.produits.panneauxLc.forEach(panneau => {
      panneau.prixTotal = calculPrixTotalVenteLc(panneau);
      panneau.extensionOpportunite.dateDisponibilite =
        panneau.extensionOpportunite.dateDisponibilite ?
          new Date(panneau.extensionOpportunite.dateDisponibilite) : null;
      panneau.extensionOpportunite.tarifInformation = panneau.extensionOpportunite.tarifInformation ? panneau.extensionOpportunite.tarifInformation : '';
      if (panneau.extensionOpportunite.urlPhoto != null) panneau.extensionOpportunite.urlPhoto = panneau.extensionOpportunite.urlPhoto.replace('http://client.affixe-logiciel.fr', 'https://secure.affixe-logiciel.fr');
    });
    panier.produits.panneauxNumeriques.forEach(panneau => {
      panneau.prixTotal = calculPrixTotalVenteNumerique(panneau);
      panneau.extensionOpportunite.tarifInformation = panneau.extensionOpportunite.tarifInformation ? panneau.extensionOpportunite.tarifInformation : '';
      if (panneau.urlPhoto != null) panneau.urlPhoto = panneau.urlPhoto.replace('http://client.affixe-logiciel.fr', 'https://secure.affixe-logiciel.fr');
    });
    return panier;
  },
  produits(state) {
    return state.opportunitePanier.panier.produits;
  },
  panneauxLcPanier(state) {
    return state.opportunitePanier.panier.produits.panneauxLc;
  },
  adressesProduitsPanier(state) {
    return state.adressesProduitsPanier;
  },
  reseauxTempoPanier(state) {
    return state.opportunitePanier.panier.produits.reseauxTempo;
  },
  reseauxLcPanier(state) {
    return state.opportunitePanier.panier.produits.reseauxLc;
  },
  panneauxNumeriquesPanier(state) {
    return state.opportunitePanier.panier.produits.panneauxNumeriques;
  },
  reseauxNumeriquesPanier(state) {
    return state.opportunitePanier.panier.produits.reseauxNumeriques;
  },
  clientPanier(state) {
    return state.opportunitePanier.clientPanier;
  },
  contactPanier(state) {
    return state.opportunitePanier.panier.contact;
  },
  ouvrirEnvoiMail(state) {
    return state.ouvrirEnvoiMail;
  },
  opportunite(state) {
    return state.opportunite;
  },
  insererPdf(state) {
    return state.insererPdf;
  },
  destinataires(state) {
    return state.destinataires;
  },
  themeCampagne(state) {
    return state.opportunitePanier.themeCampagne;
  },
  dateValidite(state) {
    if (!state.opportunitePanier.dateValidite) return null;
    return moment(state.opportunitePanier.dateValidite).toDate();
  },
  adressePanier(state) {
    return state.adressePanier;
  },
  activeTab(state) {
    return state.activeTab;
  },
  markerPointAddress(state) {
    const data = [];
    state.opportunitePanier.panier.produits.panneauxLc.map(el => el.pointAddress).forEach(obj => {
      if (obj) {
        const find = data.find(element => {
          return element.coordonnees.lat === obj.coordonnees.lat &&
            element.coordonnees.lng === obj.coordonnees.lng;
        });
        if (!find) data.push(obj);
      }
    });
    state.opportunitePanier.panier.produits.panneauxNumeriques
      .map(el => el.pointAddress).forEach(obj => {
        if (obj) {
          const find = data.find(element => {
            return element.coordonnees.lat === obj.coordonnees.lat &&
              element.coordonnees.lng === obj.coordonnees.lng;
          });
          if (!find) data.push(obj);
        }
      });
    return data;
  },
  markerFaceLC(state) {
    return state.markerFaceLC;
  },
  markerPanneauNumerique(state) {
    return state.markerPanneauNumerique;
  },
  zoomCarto: (state) => {
    return state.zoomCarto;
  },
  markerFaceReseauxLc: (state) => {
    return state.markerFaceReseauxLc;
  },
  markerFaceReseauxTempo: (state) => {
    return state.markerFaceReseauxTempo;
  },
  markerFaceReseauxNumerique: (state) => {
    return state.markerFaceReseauxNumerique;
  },
  markerFaceReseauxPerso: (state) => {
    return state.markerFaceReseauxPerso;
  },
  showProduit: (state) => {
    return state.opportunitePanier.panier.produits.panneauxLc.length
      || state.opportunitePanier.panier.produits.reseauxTempo.length
      || state.opportunitePanier.panier.produits.reseauxLc.length
      || state.opportunitePanier.panier.produits.panneauxNumeriques.length
      || state.opportunitePanier.panier.produits.reseauxNumeriques.length
      || state.opportunitePanier.panier.produits.reseauxPersonnalise.length;
  },
  prixGlobal: (state) => {
    return state.prixGlobal;
  },
  isModif: (state) => state.isModif,
  idOppModif: (state) => state.idOppModif,
  isDuplicate: (state) => state.isDuplicate,
  userIdentifiantOpp: (state) => state.userIdentifiantOpp,
  msgsErreurs: (state) => state.msgsErreurs,
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/creationOpportunite/panier.js